<template>
  <v-data-table
    :headers="headers"
    :items="tuitions"
    :items-per-page="5"
    :search="search"
    select
    class="nowrap"
    @click:row="onBillSelected"
    dense
    :loading="loading"
  >
    <template slot="top">
      <bill-viewer :bill="selected" :state="dialog" />
    </template>
    <template v-slot:[`item.code`]="{ item }">
      <router-link to @click.stop="onBillSelected(item)">{{
        item.code
      }}</router-link>
    </template>
    <template v-slot:[`item.total`]="{ item }">
      <div class="nowrap">{{ item.total | formatMoney }}</div>
    </template>
    <template v-slot:[`item.customerPaid`]="{ item }">
      <div class="nowrap">{{ item.customerPaid | formatMoney }}</div>
    </template>
    <template v-slot:[`item.liabilities`]="{ item }">
      <div class="nowrap">{{ item.liabilities | formatMoney }}</div>
    </template>
    <template v-slot:[`item.paymentType`]="{ item }">{{
      item.paymentType | getPaymentType
    }}</template>
    <template v-slot:[`item.student`]="{ item }">
      <div class="nowrap">{{ item.student.name }}</div>
    </template>
    <template v-slot:[`item.date`]="{ item }">
      <div class="nowrap">{{ item.date | familiarizeDate }}</div>
    </template>
    <template v-slot:[`item.provider`]="{ item }">
      <div class="nowrap">{{ item.provider }}</div>
    </template>
    <template v-slot:[`item.status`]="{ item }">
      <v-chip :color="getColor(item.status)" label small dark>{{
        allBillStatus[item.status]
      }}</v-chip>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import BillViewer from '@/modules/bill/BillViewerDialog'

import utils from '@/plugins/utils.js'
export default {
  components: {
    BillViewer,
  },
  props: {
    student: Object,
  },
  data() {
    return {
      search: '',
      expanded: [],
      loading: false,
      headers: [
        {
          text: 'Mã Hóa Đơn',
          align: 'left',
          sortable: false,
          value: 'code',
        },
        { text: 'Học viên', value: 'student', sortable: false },
        { text: 'Thành Tiền', align: 'right', value: 'total', sortable: false },
        {
          text: 'Đã Nộp',
          align: 'right',
          value: 'customerPaid',
          sortable: false,
        },
        {
          text: 'Dư Nợ',
          align: 'right',
          value: 'liabilities',
          sortable: false,
        },
        { text: 'Hình thức nộp', value: 'paymentType', sortable: false },
        { text: 'Hạn Nộp', value: 'date', sortable: false },
        { text: 'Trạng thái', value: 'status', sortable: false },
      ],
      dialog: false,
      selected: null,
    }
  },
  computed: {
    ...mapGetters('student', ['tuitions']),
    ...mapGetters('constant', ['billStatus', 'billTypes']),
    ...mapGetters('app', ['department']),
    allBillStatus() {
      return this.billStatus.reduce(
        (data, curent) => ({
          ...data,
          [curent.status]: curent['title'],
        }),
        {}
      )
    },
  },
  methods: {
    ...mapActions('student', ['fetchTuitions', 'setTuitions']),
    onBillSelected(bill) {
      this.selected = bill
      this.dialog = !this.dialog
    },
    async refresh(query) {
      this.loading = true
      await this.fetchTuitions({
        student: this.student.id,
      })
      this.loading = false
    },
    getColor(status) {
      if (status === 'paid') return 'green'
      else if (status === 'rejected') return 'red'
      else if (status === 'opened') return 'blue'
      else if (status === 'canceled') return 'orange'
      else return 'gray'
    },
  },
  mounted: function () {
    if (this.tuitions.length === 0) {
      this.refresh()
    }
  },
  watch: {
    student() {
      this.refresh()
    },
  },
  filters: {
    familiarizeDate: (time) => {
      if (!time) {
        return 'Không có thông tin'
      }
      return moment(time).format('HH:mm DD/MM/YYYY')
    },
    SimplizedDate: (time) => {
      if (!time) {
        return 'Không có thông tin'
      }
      return moment(time).format('DD/MM')
    },
    formatMoney(amount) {
      return utils.formatMoney(amount)
    },
    getPaymentType(paymentType) {
      if (paymentType === 'cash') {
        return 'Tiền mặt'
      } else if (paymentType === 'bank') {
        return 'Chuyển khoản'
      } else if (paymentType === 'installment') {
        return 'Trả Góp'
      } else if (paymentType === 'card') {
        return 'Quẹt thẻ'
      }
    }
  },
}
</script>
